<div class="filter position-relative d-flex justify-content-between align-items-center pl-6">
  <ng-container *ngIf="facet.selected">
    <button class="facet-lock position-absolute p-0 ml-n3"
            [attr.aria-label]="'Lock ' + facetLabel + ' facet'"
            (click)="onToggleBubbleLock(facet)"
            [attr.aria-pressed]="facet.isResetLocked"
            data-automation-id="search-facets-lock-btn">
      <span [ngClass]="facet.isResetLocked ? 'icon-lock' : 'icon-lock-open'"></span>
    </button>
  </ng-container>

  <ins-bs-checkbox [checked]="facet.selected"
                   class="w-100"
                   (change)="onChange($event.checked, facet)"
                   data-automation-id="facet-checkbox"
                   [aria-label]="facetLabel + ' ' + facet.count">
    <ng-container>
      <span class="facet-label d-block"
            [tippy]="facetLabel"
            [ngSwitch]="facet.id"
            data-automation-id="facet-label">
        <ng-container *ngSwitchCase="'at_library'">
          {{ 'at_library' | translate }}
        </ng-container>
        <ng-container *ngSwitchCase="'online'">
          {{ 'online' | translate }}
        </ng-container>
        <ng-container *ngSwitchDefault>{{facetLabel}}</ng-container>
      </span>
    </ng-container>
  </ins-bs-checkbox>

    <div class="facet-count mx-4"
         data-automation-id="facet-count"><span>{{facet.count}}</span>
    </div>
</div>
